import styled from 'styled-components';

export const EditMrdDialogStyle = styled.div`
  .disabled-input{
    .bnjtTM{
      color: #575858!important;
      background-color: white!important;
    }
  }
  .mrd-edit-form-body{
    margin: 10px;
    height: 500px;
  }
  .long-input{
    .irGLIb{
      width: 410px!important;
    }
  }
  .short-input{
    .irGLIb{
      width: 170px!important;
    }
  }
  .form-input-fields{
    min-width: 120px;
    display: table-cell;
  }
  .mrd-edit-dialog-side{
    min-width: 350px;
    width: 50%;
  }
  .mrd-edit-dialog-row{
    width: 100%;
    display: flex;
    align-items: center;
  }
  .unique-mac-error{
    color: red;
    vertical-align: super;
  }
  .css-26l3qy-menu{
    z-index: 2;
  }
`;
